import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { TripDetails } from "redmond";

import { FlightShopSummaryPanel } from "./component";
import { IStoreState } from "../../../../../../reducers/types";
import {
  getAirportMap,
  hasTravelFusionInSelectedTripDetailsSelector,
  isOutgoingMultiTicketSelector,
  isReturnMultiTicketSelector,
} from "../../../../../flight-shop/reducer";
import { getFlightTripIdentity } from "../../../../../flight-shop/utils/useFlightTripIdentity";

const mapStateToProps = (state: IStoreState) => {
  const { fareId, tripDetails } = getFlightTripIdentity(state);
  const airports = getAirportMap(state);
  const fareDetails = tripDetails
    ? tripDetails.fareDetails.find((f) => f.id === fareId)
    : undefined;

  return {
    // This component is only ever rendered by ReviewFlightItinerary, which already gates
    // on `tripDetails?.slices` before mounting it — so tripDetails is guaranteed defined here.
    tripDetails: tripDetails as TripDetails,
    fareDetails,
    airports,
    isOutgoingMultiTicket: isOutgoingMultiTicketSelector(state),
    isReturnMultiTicket: isReturnMultiTicketSelector(state),
    hasTravelFusionFareBrand:
      hasTravelFusionInSelectedTripDetailsSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightShopSummaryPanelConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightShopSummaryPanel = connector(
  withRouter(FlightShopSummaryPanel)
);
